module.exports = __webpack_public_path__ + "img/logo.5aa9e5d7.png";